"use strict";
// A web interface to manage a trail guide mobile app's content and data.
// Copyright (C) 2021-2025  David Lougheed
// See NOTICE for more information.
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var hooks_1 = require("../../modules/categories/hooks");
var CategoryTextRaw_1 = __importDefault(require("./CategoryTextRaw"));
var CategoryText = function (_a) {
    var id = _a.id, color = _a.color;
    var categories = (0, hooks_1.useCategories)().itemsByID;
    var category = categories[id];
    if (!category)
        return react_1.default.createElement("strong", null, "CATEGORY NOT FOUND");
    return react_1.default.createElement(CategoryTextRaw_1.default, { id: id, path: category.icon_svg, color: color !== null && color !== void 0 ? color : "000000" });
};
exports.default = CategoryText;
